import BlogTwo from "../components/BlogTwo";

import BrandSliderTwo from "../components/BrandSliderTwo";
import ContactForm from "../components/ContactForm";
import HomeTwoAbout from "../components/HomeTwoAbout";
import HomeTwoBanner from "../components/HomeTwoBanner";
import HomeTwoContact from "../components/HomeTwoContact";
import HomeTwoFun from "../components/HomeTwoFun";
import HomeTwoPortfolio from "../components/HomeTwoPortfolio";
import HomeTwoPriceTable from "../components/HomeTwoPriceTable";
import HomeTwoService from "../components/HomeTwoService";
import HomeTwoTeam from "../components/HomeTwoTeam";
import FooterTwo from "../footer/FooterTwo";
import OnePageHeaderTwo from "../header/OnePageHeaderTwo";


export default function OnePageTwo()
{
	return(
		<>
		<OnePageHeaderTwo/>
		<aside className="slide-bar">
			<div className="close-mobile-menu">
				<a href="javascript:void(0);"><i className="fas fa-times"></i></a>
			</div>
			
			<div className="offset-sidebar">
				<div className="offset-widget offset-logo mb-30">
					<a href="index.html">
						<img src="assets/img/logo/header-logo-1.png" alt="logo" />
					</a>
				</div>
				<div className="offset-widget mb-40">
					<div className="info-widget">
						<p className="mb-30">
							We help our clients succeed by
							creating brand identities, digital
							IT experiences, & print materials.
							Helping our clients reach their
							full potential on the market.
						</p>
						<div className="offset-social-link">
							<div className="social-icons">
								<a className="fb" href="#" target="_blank"><i className="fab fa-facebook-f"></i></a>
								<a className="ttr" href="#" target="_blank"><i className="fab fa-twitter"></i></a>
								<a className="yh" href="#" target="_blank"><i className="fab fa-yahoo"></i></a>
								<a className="yt" href="#" target="_blank"><i className="fab fa-youtube"></i></a>
							</div>
						</div>
						<div className="slidebar-address">
							<span>Get is touch</span>
							<p>2307 Beverley Rd
								Brooklyn, New York 11226
								United States.
								789 098 098 09</p>
						</div>
						<a className="theme_btn theme_btn_bg offset-sidebar-btn" href="contact.html">Contact Us <i className="fas fa-long-arrow-right"></i></a>
					</div>
				</div>
				<div className="offset-sidebar-bg"><img src="assets/img/pattern/offset-sidebar-bg.png" alt="" /></div>
			</div>
		
			<nav className="side-mobile-menu">
				<ul id="mobile-menu-active">
					<li className="has-dropdown">
						<a href="index.html">Home</a>
						<ul className="sub-menu">
							<li className="has-dropdown">
								<a href="#">Multipage</a>
								<ul className="sub-menu">
									<li><a href="index.html">Home Style 1</a></li>
									<li><a href="index-2.html">Home Style 2</a></li>
									<li><a href="index-3.html">Home Style 3</a></li>
									<li><a href="index-4.html">Home Style 4</a></li>
									<li><a href="index-5.html">Home Style 5</a></li>
									<li><a href="index-6.html">Home Style 6</a></li>
									<li><a href="index-7.html">Home Style 7</a></li>
								</ul>
							</li>
							<li className="has-dropdown">
								<a href="#">Onepage</a>
								<ul className="sub-menu">
									<li><a href="index_onepage.html">Onepage Style 1</a></li>
									<li><a href="index-2_onepage.html">Onepage Style 2</a></li>
									<li><a href="index-3_onepage.html">Onepage Style 3</a></li>
									<li><a href="index-4_onepage.html">Onepage Style 4</a></li>
									<li><a href="index-5_onepage.html">Onepage Style 5</a></li>
									<li><a href="index-6_onepage.html">Onepage Style 6</a></li>
									<li><a href="index-7_onepage.html">Onepage Style 7</a></li>
								</ul>
							</li>						
						</ul>
					</li>
					<li className="has-dropdown">
						<a href="services.html">Services</a>
						<ul className="sub-menu">
							<li><a href="services.html">Services</a></li>
							<li><a href="services-details.html">Services Details</a></li>
						</ul>
					</li>
					<li><a href="about.html">About</a></li>
					<li className="has-dropdown">
						<a href="#">Pages</a>
						<ul className="sub-menu">
							<li><a href="team.html">Team</a></li>
							<li><a href="team-details.html">Team Details</a></li>
							<li><a href="portfolio.html">Portfolio</a></li>
							<li><a href="case-details.html">Case Details</a></li>
							<li><a href="Price.html">Pricing</a></li>
							<li><a href="history.html">Our History</a></li>
							<li><a href="faq.html">Faq</a></li>
						</ul>
					</li>
					<li className="has-dropdown">
						<a href="news.html">News</a>
						<ul className="sub-menu">
							<li><a href="news.html">News</a></li>
							<li><a href="news-details.html">News Details</a></li>
						</ul>
					</li>
					<li><a href="contact.html">Contact</a></li>
				</ul>
			</nav>		
		</aside>
		<div className="body-overlay"></div>
		<main>		
		<HomeTwoBanner/>		
		<HomeTwoAbout/>	
		<HomeTwoService/>
		<HomeTwoPortfolio/>
		<BrandSliderTwo/>
		<HomeTwoFun/>	
		<HomeTwoPriceTable/>		
		<HomeTwoContact/>
		<HomeTwoTeam/>
		<BlogTwo/>
		
		<section id="contact" className="contact-area pt-120 pb-90 pt-md-60 pb-md-60 pt-xs-60 pb-xs-60">
			<div className="container">
				<div className="row">
					<div className="col-lg-6">
						<div className="section-title mb-60">
							<p className="fs-14 lh-1 mb-15">Get In Touch</p>
							<h2 className="sect-title lh-1">Let's help you!</h2>
						</div>
						<ContactForm/>
					</div>
					<div className="col-lg-6">
						<div className="contact-short-info pr-50 pr-lg-0 pr-md-0 pr-xs-0 pl-80 pl-lg-0 pl-md-0 pl-xs-0">
							<div className="section-title mb-30">
								<p className="fs-14 lh-1 mb-15">Contact Us</p>
								<h2 className="sect-title lh-1">Catch us for help</h2>
							</div>
							<div className="adress-box">
								<div className="icon-link">
									<i className="fas fa-phone"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Phone Number</p>
									<h6>890. 908. 645. 45, 908 (908) 897 89</h6>
								</div>
							</div>
							<div className="adress-box ab-2">
								<div className="icon-link">
									<i className="fas fa-envelope"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Email Address</p>
									<h6>info@webmail.com, jobs@webexample.com</h6>
								</div>
							</div>
							<div className="adress-box">
								<div className="icon-link">
									<i className="fas fa-map-marker-alt"></i>
								</div>
								<div className="address-content">
									<p className="fs-14">Office Address</p>
									<h6>12/A, Rosalina Halim Tower, New York, USA</h6>
								</div>
							</div>							
						</div>
					</div>
				</div>
			</div>
		</section>
    	<section className="contact-map-area">
			<div className="container-fluid px-0">
				<div className="contact-map">
					<iframe
						src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d14586.16663307975!2d90.3865062!3d23.941279099999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sbd!4v1641645837442!5m2!1sen!2sbd"
						 loading="lazy"></iframe>
				</div>
			</div>
		</section>
		</main>	
		<FooterTwo/>
		</>
	)
}